<template>
  <div>
    <footer>
      <img src="~@/assets/img/wzor-einsteina.png" alt="" />
      <p class="footer-contact">
        <span>Fizykoteka – Wirtualne Muzeum Wydziału Fizyki UW</span
        ><span>ul. L. Pasteura 5, pok. 0.34, 02-093 Warszawa</span
        ><span>tel.: 48 22 55 32 437, e-mail: fizykoteka@fuw.edu.pl</span>
      </p>
      <div class="footer-logos">
        <a title="Uniwersytet Warszawski" href="https://uw.edu.pl/"
          ><img src="~@/assets/img/UW_logo_pl.svg" alt=""
        /></a>
        <a
          title="Wydział Fizyki Uniwersytetu Warszawskiego"
          href="https://www.fuw.edu.pl/"
          ><img src="~@/assets/img/fizyka_uw.svg" alt=""
        /></a>
        <a
          title="Centrum Kompetencji Cyfrowych UW"
          href="https://ckc.uw.edu.pl/"
          ><img src="~@/assets/img/logo_ckc.svg" alt=""
        /></a>
      </div>
    </footer>
    <div class="footer-last-bar">
      <div>Ta witryna używa ciasteczek, możesz zablokować je w swojej przeglądarce. </div>
      <router-link :to="`/strona/informacje-prawne`" title="Informacje prawne"
        ><span>Informacje prawne</span></router-link
      >
    </div>
  </div>
</template>

<script>
// libraries
import Vivus from "vivus";



// component js

export default {
  name: "Footer",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
    };
  },
  created() {},
  mounted: function () {
      
      if (window.innerWidth <= 768) {
        this.setCookie('animated-fp', 'true', 1);
        this.setCookie('animated-noindex', 'true', 1);
      }
      
      if (!this.getCookie("animated-noindex")) 
      {
        this.toggleBodyId("addId", "animate");
      } else {
        this.toggleBodyId("removeId", "animate");
      }
      this.checkCookie("nfp");
    require("@/assets/js/scripts.js");
    // this.$loadScript("/static/assets/js/scripts.js").then(() => {
    //   window.history.replaceState(null, null, window.location.pathname);
    // });
  },
  head: {},
};
</script>

<style scoped>
footer {
  background: url("~@/assets/img/footer.svg") no-repeat top;
}
.footer-contact span {
  display: block;
}
.footer-last-bar {
  display: flex;
  align-items: baseline;
  justify-content:flex-end;
  font-size: 0.7em;
  margin-bottom: 1em;
}

.footer-last-bar div {
  padding-right: 1em;
}

.footer-last-bar a {
border-bottom: 1px solid #ccc;
}

.footer-logos a {
  padding: 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/Footer/Footer.vue